import * as Styled from './styles';
import { PlanButtonProps } from './types';

const PlanButton = ({
  type,
  children,
  className,
  onClick,
  ...props
}: PlanButtonProps): JSX.Element => (
  <Styled.PlanButton type={type} ternary className={className} onClick={onClick} {...props}>
    {children}
  </Styled.PlanButton>
);

export default PlanButton;
